import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "app" }
const _hoisted_2 = { id: "header" }
const _hoisted_3 = { id: "content" }
const _hoisted_4 = { id: "navigation" }
const _hoisted_5 = { id: "main" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppHeader = _resolveComponent("AppHeader")!
  const _component_Navigation = _resolveComponent("Navigation")!
  const _component_AppMain = _resolveComponent("AppMain")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_AppHeader)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Navigation)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_AppMain)
      ])
    ])
  ]))
}